<template>
    <div class='priceplans-details'>
      <dean-two-column-layout :title="headerTitle">
        <dean-section-title-item
            :icon="saveIcon"
            slot="title-items"
            :content="true"
            :large="true"
            @click.native="save"
        >
          Opslaan
        </dean-section-title-item>
        <div class="column" slot="left">
          <dean-form-row id="name" label="naam" v-model="data.name" type="text"/>
          <dean-multi-select-form-row key="partnerAgreementTypes" id="partnerAgreementTypes" label="Partner types"
                                      placeholder="kies een partner type" :multiple="true"
                                      :options="partnerAgreementTypes"
                                      :value="currentTypes" @select="add($event, 'partnerAgreementTypes')"
                                      @remove="remove($event, 'partnerAgreementTypes')"></dean-multi-select-form-row>
        </div>
      </dean-two-column-layout>
    </div>
</template>

<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import {
    deanSectionTitleItem,
    saveIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';

  @Component({
    components: {
      deanSectionTitleItem,
      DeanFormRow,
      DeanTwoColumnLayout,
      deanMultiSelectFormRow,
    },
  })
  export default class Details extends Vue {
    // DATA
    public data: any = {
      name: '',
      partnerAgreementTypes: [],
    };
    public partnerAgreementTypes: any[] = [];
    public saveIcon: any = saveIcon;

    // COMPUTED
    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Prijsplan wijzigen' : 'Prijsplan toevoegen';
    }

    get currentTypes() {
      const foundTypes: any[] = [];
      if (this.data.partnerAgreementTypes === null || !this.data.partnerAgreementTypes.length) {
        return null;
      }
      for (const currentValue of this.data.partnerAgreementTypes) {
        foundTypes.push(
          this.partnerAgreementTypes.find(({value}) => value === currentValue),
        );
      }
      return foundTypes;
    }

    // METHODS
    public remove(input: any, id: string) {
      if (this.data[id].includes(input.value)) {
        this.data[id] = this.data[id].filter((value: any) => {
          return value !== input.value;
        });
      }
    }

    public add(input: any, id: string) {
      if (!this.data[id].includes(input.value)) {
        this.data[id].push(input.value);
      }
    }

    public save() {
      this.$store.dispatch('setLoadOverlay', true);

      if (this.$route.params.ppId) {
        this.update();
      } else {
        this.create();
      }
    }

    public create() {
      this.$store.dispatch('processPricePlanCreate', {
        name: this.data.name,
        partnerAgreementTypes: this.data.partnerAgreementTypes,
      }).then(
        (response) => {
          this.$toast(this.$store.state.main.notification.messages.dataSaved);

          const pricePlan = response.data;

          this.$router.push({name: 'standingData.pricePlans.edit', params: {
              ppId: pricePlan.id,
            }});
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public update() {
      this.$store.dispatch('processPricePlanUpdate', {
        id: this.$route.params.ppId,
        name: this.data.name,
        partnerAgreementTypes: this.data.partnerAgreementTypes,
      }).then(
        (response) => {
          this.$toast(this.$store.state.main.notification.messages.dataSaved);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
        },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      if (this.$route.params.ppId) {
        this.createdEdit();
      } else {
        this.createdAdd();
      }
    }

    public createdEdit() {
      this.$store.dispatch('requestPricePlan', {
        id: this.$route.params.ppId,
      })
      .then(
        (response: any) => {
          const pricePlan = response.data;

          this.data.name = pricePlan.name;
          this.data.partnerAgreementTypes = pricePlan.partnerAgreementTypes.map((partnerAgreementType: any) => {
            return partnerAgreementType.id;
          });

          return this.$store.dispatch('requestPartnerAgreementTypes');
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (response) => {
          const partnerAgreementTypes = response.data.data;

          this.partnerAgreementTypes = partnerAgreementTypes.map((partnerAgreementType: any) => {
            return {
              value: partnerAgreementType.id,
              label: partnerAgreementType.name ? partnerAgreementType.name : '',
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public createdAdd() {
      this.$store.dispatch('requestPartnerAgreementTypes')
      .then(
        (response) => {
          const partnerAgreementTypes = response.data.data;

          this.partnerAgreementTypes = partnerAgreementTypes.map((partnerAgreementType: any) => {
            return {
              value: partnerAgreementType.id,
              label: partnerAgreementType.name ? partnerAgreementType.name : '',
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }
  }
</script>

<style lang="scss" scoped>

</style>
